export default __webpack_public_path__ + "static/media/SLD1-C.99497186.png";